var map = {
	"./": 138,
	"./App": 191,
	"./App.css": 1153,
	"./App.js": 191,
	"./App.scss": 420,
	"./beer.png": 112,
	"./bufficorn.png": 135,
	"./burnerloader.gif": 290,
	"./burnerwallet.png": 292,
	"./coinbase.jpg": 1154,
	"./components/Admin": 211,
	"./components/Admin.js": 211,
	"./components/Advanced": 210,
	"./components/Advanced.js": 210,
	"./components/Badge": 83,
	"./components/Badge.js": 83,
	"./components/Badges": 205,
	"./components/Badges.js": 205,
	"./components/Balance": 24,
	"./components/Balance.js": 24,
	"./components/BalanceDisplay": 449,
	"./components/BalanceDisplay.jsx": 449,
	"./components/Bottom": 27,
	"./components/Bottom.js": 27,
	"./components/BottomLinks": 263,
	"./components/BottomLinks.js": 263,
	"./components/BurnWallet": 215,
	"./components/BurnWallet.js": 215,
	"./components/CashOut": 207,
	"./components/CashOut.js": 207,
	"./components/Exchange": 216,
	"./components/Exchange.js": 216,
	"./components/Footer": 214,
	"./components/Footer.js": 214,
	"./components/Header": 195,
	"./components/Header.js": 195,
	"./components/History": 209,
	"./components/History.js": 209,
	"./components/Loader": 99,
	"./components/Loader.js": 99,
	"./components/MainCard": 208,
	"./components/MainCard.js": 208,
	"./components/Modal": 450,
	"./components/Modal.js": 450,
	"./components/MoreButtons": 98,
	"./components/MoreButtons.js": 98,
	"./components/NavCard": 23,
	"./components/NavCard.js": 23,
	"./components/Receipt": 206,
	"./components/Receipt.js": 206,
	"./components/Receive": 202,
	"./components/Receive.js": 202,
	"./components/RecentTransactions": 77,
	"./components/RecentTransactions.js": 77,
	"./components/RequestFunds": 200,
	"./components/RequestFunds.js": 200,
	"./components/Ruler": 14,
	"./components/Ruler.js": 14,
	"./components/SendBadge": 198,
	"./components/SendBadge.js": 198,
	"./components/SendByScan": 196,
	"./components/SendByScan.js": 196,
	"./components/SendToAddress": 197,
	"./components/SendToAddress.js": 197,
	"./components/SendWithLink": 201,
	"./components/SendWithLink.js": 201,
	"./components/Share": 203,
	"./components/Share.js": 203,
	"./components/ShareLink": 204,
	"./components/ShareLink.js": 204,
	"./components/Vendor": 212,
	"./components/Vendor.js": 212,
	"./components/Vendors": 213,
	"./components/Vendors.js": 213,
	"./components/WithdrawFromPrivate": 199,
	"./components/WithdrawFromPrivate.js": 199,
	"./contracts/Badges.abi": 265,
	"./contracts/Badges.abi.js": 265,
	"./contracts/Badges.address": 273,
	"./contracts/Badges.address.js": 273,
	"./contracts/Badges.blocknumber": 451,
	"./contracts/Badges.blocknumber.js": 451,
	"./contracts/Badges.bytecode": 452,
	"./contracts/Badges.bytecode.js": 452,
	"./contracts/BuffiDai.abi": 266,
	"./contracts/BuffiDai.abi.js": 266,
	"./contracts/BuffiDai.address": 274,
	"./contracts/BuffiDai.address.js": 274,
	"./contracts/BuffiDai.blocknumber": 453,
	"./contracts/BuffiDai.blocknumber.js": 453,
	"./contracts/BuffiDai.bytecode": 454,
	"./contracts/BuffiDai.bytecode.js": 454,
	"./contracts/Burner.abi": 267,
	"./contracts/Burner.abi.js": 267,
	"./contracts/Burner.address": 275,
	"./contracts/Burner.address.js": 275,
	"./contracts/Burner.blocknumber": 455,
	"./contracts/Burner.blocknumber.js": 455,
	"./contracts/Burner.bytecode": 456,
	"./contracts/Burner.bytecode.js": 456,
	"./contracts/BurnerVendor.abi": 268,
	"./contracts/BurnerVendor.abi.js": 268,
	"./contracts/BurnerVendor.address": 276,
	"./contracts/BurnerVendor.address.js": 276,
	"./contracts/BurnerVendor.blocknumber": 457,
	"./contracts/BurnerVendor.blocknumber.js": 457,
	"./contracts/BurnerVendor.bytecode": 458,
	"./contracts/BurnerVendor.bytecode.js": 458,
	"./contracts/DenDai.abi": 269,
	"./contracts/DenDai.abi.js": 269,
	"./contracts/DenDai.address": 277,
	"./contracts/DenDai.address.js": 277,
	"./contracts/DenDai.blocknumber": 459,
	"./contracts/DenDai.blocknumber.js": 459,
	"./contracts/DenDai.bytecode": 460,
	"./contracts/DenDai.bytecode.js": 460,
	"./contracts/ENS.abi": 185,
	"./contracts/ENS.abi.js": 185,
	"./contracts/ENS.address": 189,
	"./contracts/ENS.address.js": 189,
	"./contracts/ENS.blocknumber": 461,
	"./contracts/ENS.blocknumber.js": 461,
	"./contracts/ENSResolver.abi": 186,
	"./contracts/ENSResolver.abi.js": 186,
	"./contracts/ENSResolver.blocknumber": 462,
	"./contracts/ENSResolver.blocknumber.js": 462,
	"./contracts/ERC20Vendable.abi": 270,
	"./contracts/ERC20Vendable.abi.js": 270,
	"./contracts/ERC20Vendable.address": 278,
	"./contracts/ERC20Vendable.address.js": 278,
	"./contracts/ERC20Vendable.blocknumber": 463,
	"./contracts/ERC20Vendable.blocknumber.js": 463,
	"./contracts/ERC20Vendable.bytecode": 464,
	"./contracts/ERC20Vendable.bytecode.js": 464,
	"./contracts/Emitter.abi": 187,
	"./contracts/Emitter.abi.js": 187,
	"./contracts/Emitter.address": 190,
	"./contracts/Emitter.address.js": 190,
	"./contracts/Emitter.blocknumber": 465,
	"./contracts/Emitter.blocknumber.js": 465,
	"./contracts/Emitter.bytecode": 466,
	"./contracts/Emitter.bytecode.js": 466,
	"./contracts/Exchange.abi": 184,
	"./contracts/Exchange.abi.js": 184,
	"./contracts/Exchange.address": 279,
	"./contracts/Exchange.address.js": 279,
	"./contracts/Exchange.blocknumber": 467,
	"./contracts/Exchange.blocknumber.js": 467,
	"./contracts/Links.abi": 271,
	"./contracts/Links.abi.js": 271,
	"./contracts/Links.address": 280,
	"./contracts/Links.address.js": 280,
	"./contracts/Links.blocknumber": 468,
	"./contracts/Links.blocknumber.js": 468,
	"./contracts/Links.bytecode": 469,
	"./contracts/Links.bytecode.js": 469,
	"./contracts/StableCoin.abi": 188,
	"./contracts/StableCoin.abi.js": 188,
	"./contracts/StableCoin.address": 281,
	"./contracts/StableCoin.address.js": 281,
	"./contracts/StableCoin.blocknumber": 470,
	"./contracts/StableCoin.blocknumber.js": 470,
	"./contracts/StableCoin.bytecode": 471,
	"./contracts/StableCoin.bytecode.js": 471,
	"./contracts/VendingMachine.abi": 272,
	"./contracts/VendingMachine.abi.js": 272,
	"./contracts/VendingMachine.address": 282,
	"./contracts/VendingMachine.address.js": 282,
	"./contracts/VendingMachine.blocknumber": 472,
	"./contracts/VendingMachine.blocknumber.js": 472,
	"./contracts/VendingMachine.bytecode": 473,
	"./contracts/VendingMachine.bytecode.js": 473,
	"./contracts/contracts": 474,
	"./contracts/contracts.js": 474,
	"./customRPCHint.png": 294,
	"./cypherpunk.png": 136,
	"./dai.jpg": 219,
	"./ethereum.png": 111,
	"./i18n": 1,
	"./i18n/": 1,
	"./i18n/index": 1,
	"./i18n/index.js": 1,
	"./i18n/locales": 53,
	"./i18n/locales/": 53,
	"./i18n/locales/ca": 151,
	"./i18n/locales/ca.json": 151,
	"./i18n/locales/de": 152,
	"./i18n/locales/de.json": 152,
	"./i18n/locales/en": 148,
	"./i18n/locales/en.json": 148,
	"./i18n/locales/es": 150,
	"./i18n/locales/es.json": 150,
	"./i18n/locales/fr": 149,
	"./i18n/locales/fr.json": 149,
	"./i18n/locales/he": 154,
	"./i18n/locales/he.json": 154,
	"./i18n/locales/index": 53,
	"./i18n/locales/index.js": 53,
	"./i18n/locales/ro": 153,
	"./i18n/locales/ro.json": 153,
	"./i18n/locales/ru": 155,
	"./i18n/locales/ru.json": 155,
	"./i18n/locales/zh_TW": 475,
	"./i18n/locales/zh_TW.json": 475,
	"./index": 138,
	"./index.js": 138,
	"./index.scss": 298,
	"./localeth.png": 1155,
	"./qrcode.png": 291,
	"./sendwyre.png": 1156,
	"./services/wyre": 110,
	"./services/wyre.js": 110,
	"./wyre.jpg": 1157,
	"./wyre.png": 293,
	"./xdai.jpg": 137
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1152;